var React = require('react');

function Caution (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M53 11.1a3.98 3.97 0 00-.129.002 3.98 3.97 0 00-3.33 1.99l-43.8 75.8a3.98 3.97 0 003.44 5.96h87.6a3.98 3.97 0 003.44-5.96l-43.8-75.8a3.98 3.97 0 00-3.42-1.99z","fill":"#c6d65a","key":0}),React.createElement("path",{"d":"M50.9 35.2a4.03 4.03 0 00-4.03 4.03v23.1a4.03 4.03 0 004.03 4.03h4.13a4.03 4.03 0 004.03-4.03v-23.1a4.03 4.03 0 00-4.03-4.03zM53 71.2c-3.88 0-7.11 3.23-7.11 7.11 0 3.88 3.23 7.11 7.11 7.11 3.88 0 7.11-3.23 7.11-7.11 0-3.88-3.23-7.11-7.11-7.11z","fill":"#7990a6","key":1})]);
}

Caution.defaultProps = {"width":"400","height":"400","viewBox":"0 0 106 106"};

module.exports = Caution;

Caution.default = Caution;
